import type { Accessory } from '@/types/piclick';

type Props = {
  accessory: Accessory;
};

export function AccessoryPreview({ accessory }: Props) {
  const hasPhoto = !!accessory.imageUrl;

  return (
    <article className="overflow-hidden rounded-[1.5rem] border-[3px] border-plum bg-white shadow-[0_12px_28px_rgba(96,11,46,0.18)]">
      <div className="relative aspect-[4/3] bg-gradient-to-br from-cream to-white">
        {hasPhoto ? (
          <img
            src={accessory.imageUrl}
            alt={accessory.label}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center">
            <span className="font-action text-sm font-bold text-plum/40">
              Sem foto
            </span>
          </div>
        )}
        <span className="absolute left-3 top-3 inline-flex items-center rounded-full border border-plum/10 bg-white/95 px-3 py-1 font-action text-[11px] font-bold uppercase tracking-wide text-plum shadow-[0_6px_18px_rgba(96,11,46,0.08)]">
          {hasPhoto ? 'Foto real' : 'Prévia'}
        </span>
      </div>
      <div className="space-y-2 p-4">
        <p className="font-action text-base font-bold text-plum sm:text-lg">
          {accessory.label}
        </p>
        {accessory.description && (
          <p className="rounded-xl bg-pink/5 px-3 py-2 text-xs leading-relaxed text-plum/80 sm:text-sm">
            {accessory.description}
          </p>
        )}
      </div>
    </article>
  );
}
